<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V10"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.3125 2.18754C15.644 1.85602 16.0937 1.66977 16.5625 1.66977C17.0314 1.66977 17.481 1.85602 17.8125 2.18754C18.144 2.51906 18.3303 2.9687 18.3303 3.43754C18.3303 3.90638 18.144 4.35602 17.8125 4.68754L10.3017 12.1992C10.1038 12.3969 9.85937 12.5416 9.59086 12.62L7.19669 13.32C7.12499 13.341 7.04898 13.3422 6.97662 13.3237C6.90426 13.3051 6.83822 13.2675 6.7854 13.2147C6.73258 13.1618 6.69493 13.0958 6.6764 13.0234C6.65786 12.9511 6.65911 12.8751 6.68003 12.8034L7.38003 10.4092C7.4588 10.1409 7.60381 9.89675 7.80169 9.6992L15.3125 2.18754Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconEdit',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
